<template>
    <div class="imageBanner" :style="'padding: 0 ' + item.lrEdge.val + 'px;margin-top:' + item.mbConfig.val +'px;'">
        <div class="banner" :class="{'border-radius': item.bgStyle.type === 1}">
            <img v-for="(items,indexs) in item.menuConfig.list" :src="items.img">
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{
        }
    }
}
</script>

<style scoped lang="scss">
.imageBanner{
    margin-top: 10px;
    padding: 0 10px;
    .banner{
        width: 100%;
        background-color: #bfa;
        vertical-align: bottom;
    }

    .border-radius{
        border-radius: 6px;
        overflow: hidden;
    }
}
</style>